import ReasonForAbsenceModel from '@/models/bookings/reasonForAbsenceModel'
import { ReasonsForAbsence } from '@/shared/constants/booking/ReasonsForAbsence'
import config from '@/common/config'

export default {
  computed: {
    reasonsForAbsence() {
      return ReasonsForAbsence.map(
        (reason) =>
          new ReasonForAbsenceModel(reason.id, this.$t(reason.translationKey))
      )
    },
    maxNumBookingsPerDay() {
      return config.get('bookings.create.maxAllowedPerDay')
    },
  },
}
